import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { first } from 'rxjs/operators';
import { EditorService } from 'src/app/shared/services/editor-service';
import * as Editor from '../ckeditor5/build/ckeditor';
import { MailstatusService } from 'src/app/shared/services/adminpanel/mailstatus.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-draft',
  templateUrl: './add-draft.component.html',
  styleUrls: ['./add-draft.component.scss']
})
export class AddDraftComponent implements OnInit {

  [x: string]: any;

  public Editor = Editor;

  /* htmlContent = `<p style="text-align:center;"><img class="image_resized" style="width:130px;" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/2ba460c5-63d3-4d91-93cb-e4472225d9a6.png" alt="logo"></p><p style="text-align:center;"><a href="http://webmail.novuscode.com/cpsess7915627313/3rdparty/roundcube/?_task=mail&amp;_caps=pdf%3D1%2Cflash%3D0%2Ctiff%3D0%2Cwebp%3D1&amp;_uid=829&amp;_mbox=INBOX.Trash&amp;_safe=1&amp;_action=show#v1"><img class="image_resized" style="width:598px;" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/950bc10c-94e7-fac0-ae7d-af8698321db2.png" alt="Testsigma Community Edition"></a></p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Hi NA,</p><p style="margin-left:0px;">It's finally here!</p><p style="margin-left:0px;">We're thrilled and proud to announce <strong>Testsigma Community Edition (CE)</strong>, a completely open-source test automation platform.</p><p style="margin-left:0px;">The open-source edition lets you set up instantly and start automating tests in just minutes! 🤩</p><p style="margin-left:0px;">We think you'll like these features:</p><ul><li><strong>Test Recorder:</strong> Record user actions, converted into an editable test script in real-time! The test steps are in simple English statements that anyone can understand. Learn more in our recorder tutorial <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=b9bbe2bbe0&amp;e=dbc56da213">here</a>.</li><li><strong>English scripts:</strong> Write test steps in no time using simple English statements and enable everyone in your team to contribute and speed up test creation.</li><li><strong>Add-ons:</strong> We've simplified extending test scenarios with addons for 100+ automation actions and data generators accessed instantly. Check out the complete list <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=a2258d50f4&amp;e=dbc56da213">here</a>. Can't find what you need? <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=1a7bfaff99&amp;e=dbc56da213">Here's</a> our comprehensive guide to building your own!</li><li><strong>Visual Testing:</strong> By connecting your local Testsigma repository to the cloud you can compare 1000s of screens and ensure you deliver pixel-perfect UI to users. Check out all the <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=22629d9084&amp;e=dbc56da213">cloud features</a> you can access here.</li></ul><p style="margin-left:0px;">Additionally, you can shape the project with your contributions and weave your way into a community of test automation enthusiasts just like yourself.</p><div class="raw-html-embed"><p style="margin-top: 10px; line-height: 29px; margin-left: 0px; color: #000000; font-family: Roboto, sans-serif; font-size: 16px; font-weight: 300; padding-bottom: 17px; padding-left: 30px; background-color: #fff; padding-right: 40px; letter-spacing: -.39px; margin-bottom: 0px">
  <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=6a2a2bed58&amp;e=dbc56da213" style="color: #FFF; background: #03A973 !important; border: 1px solid #03A973 !important; padding: 15px 15px; border-radius: 7px; width: 100%; min-width: 50px; max-width: 150px; margin: 20px auto; display: block; text-decoration: none" class="v1btn_leep" target="_blank" rel="noreferrer"><span style="font-family: 'Mulish', sans-serif; font-size: 15px; font-weight: 500; text-align: center; margin-left: 2px; margin: auto; display: flex"><span style="padding-left: 1em">View in GitHub!</span> <img style="padding-left: 0.5em" src="https://mcusercontent.com/7b04161b831eafb922e1c9220/images/e2ff7fa5-4dfe-591c-b459-7380556f165f.png"></span></a>
 </p></div><p style="margin-left:0px;">To get the complete low-down on Testsigma CE, check out our newly revamped <a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=fef66b06e5&amp;e=dbc56da213">documentation</a>.</p><p style="margin-left:0px;">Cheers!</p><p style="margin-left:0px;">With 💚<br>Testsigma Community</p><p style="margin-left:auto;text-align:center;"><i>Connect with some of the most inventive test automation enthusiasts from across the world. </i><a href="https://testsigma.us17.list-manage.com/track/click?u=7b04161b831eafb922e1c9220&amp;id=3aef35d435&amp;e=dbc56da213"><i><strong>Join us!</strong></i></a></p>`
 */

  optionsNews = {


    // toolbar: ['undo', 'redo', '|', 'bold', 'italic', 'indent',
    //   'outdent', 'blockQuote', '|', 'heading', '|', 'bulletedList', 'numberedList',
    //   '|', 'imageUpload', 'insertTable', 'link', 'mediaEmbed', 'FontColor', 'alignment:left'
    // ],
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'link',
      'bulletedList',
      'numberedList',
      'subscript',
      'superscript',
      'strikethrough',
      '|',
      'outdent',
      'indent',
      'alignment',
      'code',
      'codeBlock',
      'fontColor',
      'fontFamily',
      'fontBackgroundColor',
      'fontSize',
      'highlight',
      'htmlEmbed',
      'pageBreak',
      '|',
      'imageInsert',
      'imageUpload',
      'blockQuote',
      'insertTable',
      'undo',
      'redo'
    ],

    image: {
      toolbar: [
        'imageTextAlternative',
        'imageStyle:inline',
        'imageStyle:block',
        'imageStyle:side',
        'linkImage'
      ],
    },
    alignment: {
      options: ['left', 'center', 'right']
    },
    fontColor: {
      colors: [
        {
          color: 'hsl(0, 75%, 60%)',
          label: 'Red'
        }
      ]
    },
    table: {
      contentToolbar: [
        'tableColumn',
        'tableRow',
        'mergeTableCells'
      ]
    }
  }
  contentFormGroup: FormGroup
  format: string;
  PhotoUploadUrl: any;
  Content: any;
  emailDraftId: any;
  constructor(private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private MailstatusService: MailstatusService,
    private matSnack: SnackbarService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.emailDraftId = localStorage.getItem('emailDraftId')
    this.contentFormGroup = this.formBuilder.group({
      content: new FormControl(''),
    })
    // this.ViewEmail()
  }
  ngAfterViewInit() {
    //  Scrolls to top of Page after page view initialized
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }

  }
  onReady(eventData) {
    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
      return new EditorService(loader);
    };
  }


  get alf() { return this.contentFormGroup.controls; }



  submit() {
    var formData: any = new FormData();
    formData.append("id", this.emailDraftId);
    formData.append("body", this.contentFormGroup.get('content').value);

    this.MailstatusService.AddEmail(formData)
        .pipe(first())
        .subscribe(
            data => {
                console.log(this.contentFormGroup.get('content').value,"content full")
                this.matSnack.showNotification("New Draft Added", "")
                this.router.navigateByUrl('/admin/email/Template')
            },
            error => {
            }
        );

}

}
